import type { CreateShopApiKeyBodyDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useCreateShopApiKey(shop: { id: string }) {
	return useApiMutation("post", "/shops/{shopId}/api/keys", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (requestBody: CreateShopApiKeyBodyDto) => ({
			params: { path: { shopId: shop.id } },
			body: requestBody,
		}),
	});
}
